module.exports = __webpack_public_path__ + "assets/img/title-e1d4220e.png";